export function createQueryParams(params) {
  return Object.keys(params)
    .map((k) => {
      return `${k}=${encodeURI(params[k])}`;
    })
    .join('&');
}
